var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import BaseMessage from './BaseMessage';
import { ErrorMessageContainer } from '../subcomponents';
var ErrorMessage = function (_a) {
    var id = _a.id, image = _a.image, title = _a.title, subTitle = _a.subTitle, extraInfo = _a.extraInfo;
    return (_jsx(ErrorMessageContainer, __assign({ top: "xxlarge" }, { children: _jsx(BaseMessage, { id: id, image: image, title: title, subTitle: subTitle, extraInfo: extraInfo }) })));
};
export default ErrorMessage;
